module.exports = __webpack_public_path__ + "img/menu-second.7a359b3b.svg";